const routerCheck = {
  created() {
    this.$userStory.updateCurrentByPath(this.$route.path)
  },
}

export default routerCheck
